import { render } from "./Check.vue?vue&type=template&id=b4cc7bb4&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import "./Check.vue?vue&type=style&index=0&id=b4cc7bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4cc7bb4"]])

export default __exports__